import { useState, useEffect, useCallback, useMemo } from "react";
import { connect } from "react-redux";
import Helmet from "react-helmet";
import { Link } from "react-router-dom";
//imported
import { PRACTITIONER, TRASH_BIN } from "common/viewContent";
import { CONFIRM_ALERT, DELETE_ALERT } from "common/constantMessage";
import * as Path from "routes/paths";
import { DATE_FORMAT, FORMAT_TEXT, formatText, userFullName } from "helpers/common";
import ReactPagination from "components/shared/ReactPagination";
import { Button, Form } from "react-bootstrap";
import ReportDateRange from "../dashboard/Component/ReportDateRange";
import { debounce } from "lodash";
import SortableTable from "components/shared/SortableTable";
import { useCreateProduct, useGetTrashBinItems, useRestoreItem } from "hooks/reactQuery/useTrashBin";
import { generatePath } from "react-router-dom";
import LoadingSkeleton from "components/shared/LoadingSkeleton/Index";
import parse from "html-react-parser"
import { getUsersList } from "store/services/auditLogsService";
import AppAsyncSelect from "components/shared/FormComponents/AppAsyncSelect";
import RestoreConfirmationPopup from "./Components/RestoreConfirmationPopup";
// import { PRODUCT_MANUFACTURE_OPTIONS } from "common/constants";

const defaultFilters = {
  order: "desc",
  orderBy: "created_at",
  entity_type: "",
  // entity_id: "",
  pract_id: "",
  status: "trashed",
};

const List = ({
  dispatch,
  practitionerList,
  itemsCountPerPage,
  totalItemsCount,
  instancesList
}) => {
  //pagination
  const limit = 10;
  const [activePage, setActivePage] = useState(1);
  const [searchFilter, setsearchFilter] = useState({...defaultFilters});

  const { data: response, isLoading, refetch } = useGetTrashBinItems({ limit, page: activePage, ...searchFilter });
  const { data, total_count: totalCount } = response?.body || {};

  useEffect(() => {
    setActivePage(1);
  }, [searchFilter])

  const handleDebounceSearch = useCallback(debounce((e) => {
    setsearchFilter((prev) => ({
      ...prev,
      search: e.target.value,
    }))
  }, 500), []);

  const handleChangeSorting = (orderBy, sortOrder) => {
    setsearchFilter((prev) => ({
      ...prev,
      orderBy,
      sortOrder,
    }))
  }

  //delete
  const deleteItem_ = async (id) => {
    try {
      await DELETE_ALERT()
    } catch (err) {
      console.log(err);
    }
  };

  //pagination
  const handlePageChange = (page) => {
    setActivePage(page);
    window.scrollTo(0, 0);
  };
  //filter
  const handleSearchFilter = (e) => {
    let { name, value } = e.target;
    setsearchFilter({ ...searchFilter, [name]: value });
  };

  const handleSearchUsers = async (search) => {
    const response = await getUsersList({ search, limit: 100, role: "practitioner", status: "active" });
    const users = response?.body?.data || [];
    return users.map((user) => ({
      value: user.id,
      label: `${userFullName(user)} (${user.email})`,
    }));
  };

  const columns = useMemo(() => {
    return [
      {
        key: "entity_type",
        label: "Entity Type",
        sortable: true,
        render: (item) => formatText(item?.entity_type)
      },
      // {
      //   key: "name",
      //   label: "Entity Name",
      //   sortable: true,
      //   render: (item) => {
      //     return (
      //       <>
      //         {item?.entity_type === "todo" && (
      //           <div>{item?.metadata?.form_name}</div>
      //         )}

      //         {item?.entity_type === "client" && (
      //           <div>{userFullName(item.client)}</div>
      //         )}
      //       </>
      //     )
      //   }
      // },
      {
        key: "practitioner",
        label: "Practitioner Name",
        render: (item) => userFullName({
          first_name: item?.first_name,
          last_name: item?.last_name,
        })
      },
      {
        key: "created_at",
        label: "Deleted At",
        sortable: true,
        render: (item) => DATE_FORMAT(item.created_at),
      },
      {
        key: "expire_at",
        label: "Expires At",
        sortable: true,
        render: (item) => DATE_FORMAT(item.expire_at),
      },
      {
        key: "reason",
        label: "Reason",
        render: (item) => item.reason,
      },
      {
        key: "is_active",
        label: "Status",
        sortable: true,
        render: (item) => (
          <div>
            {item?.status === "trashed" ? "Deleted" : formatText(item?.status)}
          </div>
        ),
      },
      {
        key: "Action",
        label: "Action",
        // sticky: true,
        // className: "sticky",
        render: (item) => (
          <div className="d-flex align-items-center gap-10 tableBtn justify-content-center">
            <Link
              to={generatePath(Path.trash_bin_detail, { id: item.id })}
              title="View"
            >
              <i className="fa fa-lg fa-eye"></i>
            </Link>
          </div>
        )
      },
    ]
  }, []);

  return (
    <>
      <Helmet title={TRASH_BIN.CURRENT_MODULE} />
      {isLoading && (
        <LoadingSkeleton />
      )}
      <section className="section">
        <div className="section-header">
          <h1>{TRASH_BIN.CURRENT_MODULE}</h1>
          {/* <div className="section-header-button">
            <Link to={Path.trash_bin} className="btn btn-primary">
              Add New
            </Link>
          </div> */}
          <div className="section-header-breadcrumb">
            <div className="breadcrumb-item">{TRASH_BIN.CURRENT_MODULE}</div>
          </div>
        </div>
        <div className="section-body">
          <h2 className="section-title">{TRASH_BIN.CURRENT_MODULE}</h2>
          <p className="section-lead">
            In this section, you can view a list of deleted items, allowing you to efficiently manage them by performing actions like restoring or permanently deleting records as needed.
          </p>

          <div className="row">
            <div className="col-12">
              <div className="card">
                {/* <div className="card-header d-flex justify-content-between">
                  <div className="d-flex align-items-center gap-10">
                    <h4>{TRASH_BIN.TOP_CONTENT}</h4>
                    <div className="searchForm position-relative iconWithText">
                      <input
                        type="text"
                        placeholder="Search...."
                        className="form-control"
                        name="search"
                        onChange={handleDebounceSearch}
                      />
                      <Button
                        className="border-0 p-0 position-absolute icn"
                        variant="transparent"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                        >
                          <path
                            d="M16.031 14.617L20.314 18.899L18.899 20.314L14.617 16.031C13.0237 17.3082 11.042 18.0029 9 18C4.032 18 0 13.968 0 9C0 4.032 4.032 0 9 0C13.968 0 18 4.032 18 9C18.0029 11.042 17.3082 13.0237 16.031 14.617ZM14.025 13.875C15.2941 12.5699 16.0029 10.8204 16 9C16 5.133 12.867 2 9 2C5.133 2 2 5.133 2 9C2 12.867 5.133 16 9 16C10.8204 16.0029 12.5699 15.2941 13.875 14.025L14.025 13.875Z"
                            fill="#08415C"
                          />
                        </svg>
                      </Button>
                    </div>
                  </div>
                </div> */}
                <div className="card-body">
                  <div className="TableFilter d-flex align-items-center justify-content-between gap-10 flex-wrap">
                    <div className="left d-flex align-items-end gap-10">
                      <div className="">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold m-0 me-2 ws-nowrap"
                        >
                          Filter By Entity Type:
                        </label>
                        <Form.Select
                          aria-label="Default select example"
                          name="entity_type"
                          className="form-control"
                          onChange={handleSearchFilter}
                        >
                          <option value={""}>All</option>
                          <option value={"todo"}>To-Do</option>
                          <option value={"client"}>Client</option>
                          <option value={"tag"}>Tag</option>
                          <option value={"document"}>Document</option>
                          <option value={"form"}>Form</option>
                          <option value={"package"}>Package</option>
                          <option value={"client_document"}>Client Document</option>
                          <option value={"document_note"}>Document Note</option>
                          <option value={"notes"}>Notes</option>
                        </Form.Select>
                      </div>
                      <div className="">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold m-0 me-2 ws-nowrap"
                        >
                          Search:
                        </label>
                        <div className="searchForm position-relative iconWithText">
                          <AppAsyncSelect
                            onChange={(selected) => handleSearchFilter({ target: {
                              name: "pract_id",
                              value: selected?.value
                            }})}
                            fetchOptions={handleSearchUsers}
                            placeholder="Search by User Name/Email"
                            classNamePrefix="nta"
                          />
                        </div>
                      </div>
                      <div className="">
                        <label
                          htmlFor=""
                          className="form-label fw-sbold m-0 me-2 ws-nowrap"
                        >
                          Filter By Status:
                        </label>
                        <Form.Select
                          aria-label="Default select example"
                          name="status"
                          className="form-control"
                          onChange={handleSearchFilter}
                          value={searchFilter.status}
                        >
                          <option value={""}>All</option>
                          <option value={"trashed"}>Deleted</option>
                          <option value={"restored"}>Restored</option>
                        </Form.Select>
                      </div>
                    </div>
                    <div className="right d-flex align-items-center gap-10">
                    </div>
                  </div>
                  <div className="table-responsive">
                    <SortableTable
                      indexColumn={true}
                      columns={columns}
                      data={data}
                      onSort={handleChangeSorting}
                      sortColumn={searchFilter?.orderBy}
                      sortOrder={searchFilter?.sortOrder}
                      isLoading={isLoading}
                    />
                  </div>
                  {data?.length > 0 && (
                    <ReactPagination
                      activePage={activePage}
                      itemsCountPerPage={limit}
                      totalItemsCount={totalCount}
                      handlePageChange={handlePageChange}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    practitionerList: state.Practitioner.practitioners,
    instancesList: state.Configuration.instanceTypeList,
    loader: state.Practitioner.loader,
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToProps, mapDispatchToProps)(List);
